import { Plugin, ButtonView } from 'ckeditor5';

// #subscriber-notdeactivated
const optInPlaceholderIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M11.33 12.42a0.46 0.46 0 0 0 0.11 -0.4 0.49 0.49 0 0 0 -0.22 -0.34 7.47 7.47 0 0 0 -4 -1.18A7.55 7.55 0 0 0 0 15.86a0.5 0.5 0 0 0 0.08 0.44 0.48 0.48 0 0 0 0.4 0.2h8.67a0.49 0.49 0 0 0 0.49 -0.41 8 8 0 0 1 1.69 -3.67Z"></path><path d="M2.25 4.75a4.75 4.75 0 1 0 9.5 0 4.75 4.75 0 1 0 -9.5 0"></path><path d="M23.05 18.19a1 1 0 0 0 -1.25 0.66A4.5 4.5 0 1 1 17.5 13a1 1 0 0 0 0 -2 6.5 6.5 0 1 0 6.2 8.44 1 1 0 0 0 -0.65 -1.25Z"></path><path d="m22.29 12.67 -4.44 4.44a0.5 0.5 0 0 1 -0.7 0l-1 -1a1 1 0 0 0 -1.41 0 1 1 0 0 0 0 1.41l1.58 1.58a1.69 1.69 0 0 0 2.38 0l5 -5a1 1 0 0 0 0 -1.41 1 1 0 0 0 -1.41 -0.02Z"></path></g></svg>`;
// #subscriber-deactivated
const optOutPlaceholderIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M11.33 12.42a0.46 0.46 0 0 0 0.11 -0.4 0.49 0.49 0 0 0 -0.22 -0.34 7.47 7.47 0 0 0 -4 -1.18A7.55 7.55 0 0 0 0 15.86a0.5 0.5 0 0 0 0.08 0.44 0.48 0.48 0 0 0 0.4 0.2h8.66a0.49 0.49 0 0 0 0.49 -0.41 8.06 8.06 0 0 1 1.7 -3.67Z"></path><path d="M2.25 4.75a4.75 4.75 0 1 0 9.5 0 4.75 4.75 0 1 0 -9.5 0"></path><path d="M17.5 11a6.5 6.5 0 1 0 6.5 6.5 6.51 6.51 0 0 0 -6.5 -6.5Zm3.5 7.5h-7a1 1 0 0 1 0 -2h7a1 1 0 0 1 0 2Z"></path></g></svg>`;
// #subscriber-whatsapp
const profileNamePlaceholderIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="cls-1" d="M11.35,12.42c.1-.11.14-.26.11-.4-.02-.14-.1-.26-.22-.34-1.19-.77-2.58-1.17-4-1.18-3.32,0-6.26,2.18-7.22,5.36-.04.15-.01.31.08.44.09.13.24.2.4.2h8.67c.24,0,.45-.17.49-.41.24-1.35.82-2.61,1.69-3.67Z"/><path class="cls-1" d="M2.27,4.75c0,2.62,2.13,4.75,4.75,4.75s4.75-2.13,4.75-4.75S9.64,0,7.02,0,2.27,2.13,2.27,4.75"/><path class="cls-1" d="M17.51,11.07c-3.57,0-6.47,2.88-6.5,6.45,0,1.31.4,2.59,1.16,3.66l-.74,2.17c-.03.1,0,.2.06.28.07.07.18.1.28.06l2.27-.72c3,1.93,7,1.06,8.93-1.94,1.93-3,1.06-7-1.94-8.93-1.05-.68-2.28-1.03-3.53-1.03ZM21.41,20.12c-.37.7-1.1,1.14-1.89,1.13-.65-.07-1.28-.26-1.87-.54-1.32-.6-2.44-1.57-3.22-2.79-1.04-1.37-1.08-2.65-.09-3.71.28-.26.66-.37,1.04-.3.28.04.53.22.65.48l.21.5.34.82c.09.17.09.37,0,.54-.14.28-.32.53-.54.74.28.42.61.81.97,1.16.44.38.94.68,1.48.89.15-.2.44-.54.54-.69.15-.25.47-.33.73-.19.21.07,1.36.64,1.36.64.15.05.28.14.37.27.17.35.14.76-.07,1.08Z"/></svg>`;

export default class WhatsAppDoiPlaceholder extends Plugin {
    static get pluginName() { return "WhatsAppDoiPlaceholder"; }

    static get requires() { return ['Placeholder']; }

    init() {
        const editor = this.editor;
        const { t } = editor.locale;

        editor.ui.componentFactory.add('whatsAppOptInKeyword', locale => {
            const toolbarItem = new ButtonView(locale);
            toolbarItem.set({
                label: t('WhatsAppOptInKeyword'),
                withText: false,
                tooltip: true,
                isToggleable: false,
                icon: optInPlaceholderIcon,
            });

            toolbarItem.on('execute', () => {
                editor.execute('placeholder', { placeholder: 'wa:optin' })
            });

            return toolbarItem;
        });

        editor.ui.componentFactory.add('whatsAppOptOutKeyword', locale => {
            const toolbarItem = new ButtonView(locale);
            toolbarItem.set({
                label: t('WhatsAppOptOutKeyword'),
                withText: false,
                tooltip: true,
                isToggleable: false,
                icon: optOutPlaceholderIcon,
            });

            toolbarItem.on('execute', () => {
                editor.execute('placeholder', { placeholder: 'wa:optout' })
            });

            return toolbarItem;
        });

        editor.ui.componentFactory.add('whatsAppProfileNamePlaceholder', locale => {
            const toolbarItem = new ButtonView(locale);
            toolbarItem.set({
                label: t('WhatsAppProfileName'),
                withText: false,
                tooltip: true,
                isToggleable: false,
                icon: profileNamePlaceholderIcon,
            });

            toolbarItem.on('execute', () => {
                editor.execute('placeholder', { placeholder: 'wa:username' })
            });

            return toolbarItem;
        });
    }
}
